import React from 'react';
import { Check } from 'lucide-react';
import { pricingPlans } from '../mockData';
import { Button } from './ui/button';
import { Card } from './ui/card';

export const PricingSection = ({ onOpenPopup }) => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#58225a] mb-4">Choose the Right Protection Package</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Straightforward pricing without hidden fees. Select the package that best suits your requirements and budget.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {pricingPlans.map((plan) => (
            <Card
              key={plan.id}
              className={`relative p-6 flex flex-col h-full ${
                plan.recommended
                  ? 'border-2 border-[#e8a8c8] shadow-xl'
                  : 'border border-gray-200'
              }`}
            >
              {plan.recommended && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <span className="bg-[#ba2a84] text-white px-4 py-1 rounded-full text-sm font-semibold">
                    Recommended
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-[#58225a] mb-2">{plan.name}</h3>
                <div className="flex items-baseline justify-center">
                  <span className="text-4xl font-bold text-primary">${plan.price}</span>
                  {/* <span className="text-gray-600 ml-2">+ Federal Filing Fee</span> */}
                </div>
              </div>

              <div className="flex-1 mb-6">
                <ul className="space-y-3 max-h-64 overflow-y-auto">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <Check className="h-5 w-5 text-[#e8a8c8] mr-2 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="text-xs text-gray-500 mb-4 text-center">
                {plan.note}
              </div>

              <Button
                onClick={onOpenPopup}
                className={`w-full ${
                  plan.recommended
                    ? 'bg-[#ba2a84] hover:bg-[#8a1f63] text-white'
                    : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
                }`}
                data-testid={`pricing-${plan.name.toLowerCase()}-btn`}
              >
                Get Started Now
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
